import Modal2 from 'components/commons/modal/Modal2';
import React from 'react';

export const TargetReturnModal = ({
  isShow,
  hide,
}: {
  isShow: boolean;
  hide: () => void;
}): React.ReactElement => {
  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4">
          <div className="flex flex-row">
            <div className="text-lg font-bold">ターゲットリターンとは</div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="text-sm pt-4">
            目標とする利回りです。
            <br />
            あなたが立てた資産目標を達成するために必要な利回りを、ここではターゲットリターンとして設定しています。
          </div>
          <div
            className="flex justify-center text-gray-500 m-1 p-2 cursor-pointer"
            onClick={hide}>
            閉じる
          </div>
        </div>
      </Modal2>
    </>
  );
};
